// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"201":"65cc66d7","235":"319d8c1a","301":"4eb4dbb1","385":"d9a66c99","566":"c44ae352","609":"bc717109","625":"808f6fe0","703":"c149bea5","751":"b795c786","983":"f8c0b899"}[chunkId] + ".chunk.css";
};